import { useEffect, useState } from 'react';
import { AuthApiClient } from '@/features/auth/api/AuthApiClient';
import { useApiClient } from '@/hooks/useApiClient';

export interface CompanyProfile {
  /** Company of the logged-in user, `''` until the profile answers (or when it has none). */
  companyName: string;
  /** True once `companyName` was filled from the profile rather than typed by the user. */
  companyAutoFilled: boolean;
}

/**
 * Pre-fills the company from the logged-in user's profile. Best effort: a failed or aborted
 * profile request leaves both values untouched, and the forms stay usable.
 */
export function useCompanyProfile(): CompanyProfile {
  const http = useApiClient();
  const [companyName, setCompanyName] = useState('');
  const [companyAutoFilled, setCompanyAutoFilled] = useState(false);

  useEffect(() => {
    if (!http) return;
    const ac = new AbortController();
    new AuthApiClient(http)
      .getProfile({ signal: ac.signal })
      .then((res) => {
        if (ac.signal.aborted) return;
        if (res.ok && res.data.profile.companyName.trim() !== '') {
          setCompanyName(res.data.profile.companyName);
          setCompanyAutoFilled(true);
        }
      })
      .catch(() => {});
    return () => ac.abort();
  }, [http]);

  return { companyName, companyAutoFilled };
}
